module.exports = __webpack_public_path__ + "img/NAVISTAR.a921f317.svg";